import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Box, Menu, MenuItem } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { NavigationTab } from '../../model/navigation/types';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
    title: string;
    icon: JSX.Element;
    tabs: NavigationTab[];
    loggedInUser: string;
    currentTab: NavigationTab;
    onDrawerToggle: () => void;
    onTabClick: (value: string) => void;
    onLogout: () => void;
}

export default function Header(props: HeaderProps) {
  const { t } = useTranslation();
  const { onDrawerToggle, onTabClick, onLogout, title, icon, tabs, currentTab } = props;
  const [profileMenu, setProfileMenu] = React.useState(null);
  const open = Boolean(profileMenu);
  const handleClick = (event: any) => {
    setProfileMenu(event.currentTarget);
  };
  const handleClose = () => {
    setProfileMenu(null);
  };

  return (
    <React.Fragment>
      <AppBar color="primary" position="sticky" elevation={0}>
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            <Grid sx={{ display: { sm: 'none', xs: 'block' } }} item>
              <IconButton
                color="secondary"
                aria-label="open drawer"
                onClick={onDrawerToggle}
                edge="start"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid item xs />
            <Grid item>
              <Box sx={{ m: 1, display: 'inline', color: "#70405f", fontSize: 14 }}>
              {props.loggedInUser}
              </Box>
              <IconButton color="inherit" sx={{ p: 0.5 }} onClick={handleClick}>
                <Avatar />
              </IconButton>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar
        component="div"
        color="primary"
        position="static"
        elevation={0}
        sx={{ zIndex: 0 }}
      >
        <Toolbar>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
                <Box sx={{color: "#70405f", display: "inline-block"}}>
                    {icon}
                </Box>
                <Typography color="inherit" variant="h5" component="h1" sx={{fontWeight: "bold", color: "#70405f", margin: "5px", display: "inline-block"}}>
                    {t(title)}
                </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar component="div" position="static" elevation={0} sx={{ zIndex: 0 }}>
        <Tabs value={currentTab.id} textColor="inherit">
            {tabs.map((tab: NavigationTab, index: number)=>{
                return (<Tab key={`header-tab-${tab.id}`} label={t(tab.title)} value={tab.id} onClick={()=>{onTabClick(tab.id)}}/>);
            })}
        </Tabs>
      </AppBar>
      <Menu
        id="basic-menu"
        anchorEl={profileMenu}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={onLogout}>
            <Logout sx={{margin: "5px"}}/>{t('general.logout')}
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}